import React from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// Screens
import Homepage from "./screens/Homepage.jsx";
import Datenschutz from './screens/Datenschutz.jsx';

export default function App() {
  return (
    <BrowserRouter basename="/">
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
        <link href="/style/tailwind.css" rel="stylesheet" />
      </Helmet>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
    </BrowserRouter>
  );
}
